<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <template v-if="notes.length == 0 && loaded">
      <b-row>
        <b-col lg="12">
          <b-alert show>Pas de notes non lues</b-alert>
        </b-col>
      </b-row>
    </template>
    <b-row v-if="loaded">
      <b-col lg="12">
        <b-card
          class="mb-3 mx-2 shadow bg-light"
          title-tag="h6"
          title="Notes nécessitant une attention particulière"
        >
          <b-table small fixed striped hover :items="notes" :fields="notesFields">
            <template v-slot:cell(when)="data">{{
              toDate(data.item.when)
            }}</template>
            <template v-slot:cell(mandatID)="data">
              <b-link
                :to="{
                  name: 'warrantView',
                  params: { id: data.item.mandatID, tab: 'notes' },
                }"
              >
                {{ data.item.mandatID }}
              </b-link>
            </template>
            <template v-slot:cell(creancier)="data">
              <b-link
                :to="{
                  name: 'creditorView',
                  params: { id: data.item.creancierID },
                }"
              >
                {{ data.item.creancier }}
              </b-link>
            </template>
            <template v-slot:cell(debiteur)="data">
              <b-link
                :to="{
                  name: 'debtorView',
                  params: { id: data.item.debiteurID },
                }"
              >
                {{ data.item.debiteur }}
              </b-link>
            </template>
            <template v-slot:cell(content)="data">
              
              <div v-html="data.item.content" class="note-content"></div>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import warrants from "@/services/warrants";
import DateTime from "@/services/DateTime.js";
export default {
  data() {
    return {
      notes: [],
      loaded: false,
      notesFields: [
        {
          key: "when",
          thStyle: { minWidth: '150px'},
          label: "Date",
          sortable: true,
        },
        {
          key: "mandatID",
          label: "Mandat",
          class: "text-center",
          sortable: true,
          thStyle: { width: '100px'},
        },
        {
          key: "creancier",
          label: "Créancier",
          class : 'text-truncate',
          sortable: true,
        },
        {
          key: "debiteur",
          label: "Debiteur",
          class: 'text-truncate',
          sortable: true,
        },
        {
          key: "content",
          label: "Note",
          thStyle: {width: '60%' },
        },
        {
          key: "initiale",
          label: "Négociateur",
          sortable: true,
          thStyle: {width: '5%' },
        },
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Notes non lues",
          active: true,
        },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      warrants.unread_notes().then((response) => {
        this.notes = response.data;
        if(this.$store.getters.isNego) {
          this.notes = this.notes.filter(x => x.type != 'admin');
        }
        this.loaded = true;
      });
    },
    toDate(d) {
      return DateTime.humanDateTime(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.note-content p {
  margin-bottom: 0px;
}
</style>